/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState } from 'react';
import * as d3 from 'd3';
import DetailedCard from './DetailedCard';

class LRUCache {
    constructor(limit) {
        this.limit = limit;
        this.map = new Map();
    }

    get(key) {
        if (!this.map.has(key)) return null;
        const value = this.map.get(key);
        this.map.delete(key);
        this.map.set(key, value);
        return value;
    }

    set(key, value) {
        if (this.map.size >= this.limit) {
            const firstKey = this.map.keys().next().value;
            this.map.delete(firstKey);
        }
        this.map.set(key, value);
    }
}

const setSearchCard = async (card, setExtraVisible, transition) => {
    setExtraVisible(card);
    await new Promise(resolve => setTimeout(resolve, transition));
    setExtraVisible(undefined);
}
const COLORS = {
    B: '#110C0E',
    W: '#EDE5D3',
    U: '#AFD8EF',
    G: '#A2CBA9',
    R: '#F3A992',
    C: '#777777',
    'common': '#777',
    'uncommon': '#A5A9B4',
    // 'rare': '#f5c669',
    'rare': '#bbA53D',
    'mythic': '#C15516',
    'special': '#A2CBA9',
    'bonus': '#AFD8EF',
  }

function drawColoredSectors(context, x, y, radius, colors) {
    const numSectors = colors.length;
    const anglePerSector = (2 * Math.PI) / numSectors;
  
    for (let i = 0; i < numSectors; i++) {
      context.beginPath();
      context.moveTo(x, y); // Move to the center of the circle
      context.arc(
        x, y, 
        radius, 
        i * anglePerSector, 
        (i + 1) * anglePerSector
      );
      context.closePath(); // Connect the end point of the arc back to the center
      context.fillStyle = COLORS[colors[i]]; // Set the fill color
      context.fill(); // Fill the sector with color
    }
  }

// const IMAGE_LOW_URL = 'https://storage.cloud.google.com/imatges-mtg/images_small/';
const IMAGE_LOW_URL = 'https://cards.scryfall.io/small/front/';
const IMAGE_URL = 'https://cards.scryfall.io/large/front/';

const CanvasPoints = ({ data, width, height, values, searched, useColors, setThisZoom, thisZoom, setSearched, currentCoord, fullData }) => {
    const canvasRef = useRef(null);
    const transformRef = useRef(d3.zoomIdentity);
    const zoomRef = useRef(null);
    const imageCache = useRef(new LRUCache(1000));
    const transitionDuration = values.transitionTime;
    const [extraVisible, setExtraVisible] = useState(undefined);
    const valueRef = useRef(extraVisible);
    const backImageRef = useRef(null);
    // const backImage = new Image();
    // backImage.src = `https://storage.cloud.google.com/imatges-mtg/images_small/back.png`

    useEffect(() => {
        const loadBackImage = () => {
            const img = new Image();
            // img.src = 'https://storage.cloud.google.com/imatges-mtg/images_small/back.png';
            img.src = 'https://martirubiobucket-mtg.s3.eu-central-1.amazonaws.com/images_small_back.png';
            img.onload = () => {
                backImageRef.current = img;
            };
        };
    
        loadBackImage();
    }, []);

    const [modalOpen, setModalOpen] = useState(false);
    const [overlayContent, setOverlayContent] = useState(null);

    useEffect(() => {
        valueRef.current = extraVisible;
    }, [extraVisible]);

    const renderPoints = (visible) => {
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');
        context.save();
        context.clearRect(0, 0, canvas.width, canvas.height);

        let new_r = 30 - 30*(values.zoomDisplayImages - transformRef.current.k)/values.zoomDisplayImages;
        if (new_r < 0) new_r = 1;

        visible.sort((a, b) => a.zIndex - b.zIndex).forEach((d) => {
            const x = transformRef.current.applyX(d[`${currentCoord}_x`]);
            const y = transformRef.current.applyY(d[`${currentCoord}_y`]);

            context.beginPath();
            if (transformRef.current.k > values.zoomDisplayImages) {
                // const imageUrl = `https://storage.cloud.google.com/imatges-mtg/images_small/${d.image_url.split('/').pop()}`;
                // const imageUrl = IMAGE_LOW_URL + d.image_id;
                const imageUrl = `${IMAGE_LOW_URL}${d.image_id[0]}/${d.image_id[1]}/${d.image_id}`;
                let img = imageCache.current.get(imageUrl);
                if (img) {
                    context.drawImage(img, x - values.width/2, y - values.height/2, values.width, values.height);
                } else {
                    if (backImageRef.current) {
                        context.drawImage(backImageRef.current, x - values.width/2, y - values.height/2, values.width, values.height);
                    }
                    img = new Image();
                    img.src = imageUrl;
                    img.onload = () => {
                        imageCache.current.set(imageUrl, img);
                        // TODO: si descomento aleshores es veuen multiples vegades
                        // si no, només carrega si faig un moviment.
                        // context.drawImage(img, x, y, values.width, values.height);
                    };
                }
            } else {
                if (!useColors) {
                    drawColoredSectors(context, x, y, new_r, d.colors);
                } else {
                    // context.fillStyle = '#313638'
                    context.fillStyle = COLORS[d.rarity];
                    context.arc(x, y, new_r, 0, 2 * Math.PI);
                }
                context.fill();
            }
        });
        if (valueRef.current) {
            const x = transformRef.current.applyX(valueRef.current[`${currentCoord}_x`]);
            const y = transformRef.current.applyY(valueRef.current[`${currentCoord}_y`]);

            context.beginPath();
            // const imageUrl = `https://storage.cloud.google.com/imatges-mtg/images_small/${valueRef.current.image_url.split('/').pop()}`;
            // const imageUrl = IMAGE_LOW_URL + valueRef.current.image_id;
            const imageUrl = `${IMAGE_LOW_URL}${valueRef.current.image_id[0]}/${valueRef.current.image_id[1]}/${valueRef.current.image_id}`;
            let img = imageCache.current.get(imageUrl);
            if (img) {
                context.drawImage(img, x - values.width/2, y - values.height/2, values.width, values.height);
            } else {
                img = new Image();
                img.src = imageUrl;
                img.onload = () => {
                    imageCache.current.set(imageUrl, img);
                    // TODO: si descomento aleshores es veuen multiples vegades
                    // si no, només carrega si faig un moviment.
                    // context.drawImage(img, x, y, values.width, values.height);
                };
            }
        }
        context.restore();
    };

    const getVisiblePoints = (data, transform, width, height) => {
        return data.filter(d => {
            const x = transform.applyX(d[`${currentCoord}_x`]);
            const y = transform.applyY(d[`${currentCoord}_y`]);
            return x >= -500 && x <= width + 300 && y >= -500 && y <= height + 300;
        });
    };

    const updateVisiblePoints = () => {
        const visible = getVisiblePoints(data, transformRef.current, width, height);
        renderPoints(visible);
    };

    const setDetailedCard = (topmostImage) => {
        setOverlayContent({...topmostImage, allImagesUrl: fullData.filter((t) => t.name === topmostImage.name).map((p) => `${IMAGE_URL}${p.image_id[0]}/${p.image_id[1]}/${p.image_id}`)});
        setModalOpen(true); // Open the modal
    }

    const animateZoom = (startTransform, endTransform, duration) => {
        const startTime = performance.now();
        const pauseDuration = 500; // 500ms pause at origin
        const totalDuration = duration + pauseDuration;
    
        const animate = (time) => {
            const elapsed = time - startTime;
            let t = Math.min(1, elapsed / totalDuration);
            
            let k, x, y;

            if (startTransform.k < 10) {
                k = startTransform.k * (1 - t) + endTransform.k * t;
                x = startTransform.x * (1 - t) + endTransform.x * t;
                y = startTransform.y * (1 - t) + endTransform.y * t;
            } else {
                if (t < 1/2) {
                    // First third: zoom out to origin
                    const t1 = t * 2;
                    k = startTransform.k * (1 - t1) + 1 * t1;
                    x = startTransform.x * (1 - t1) + 0 * t1;
                    y = startTransform.y * (1 - t1) + 0 * t1;
                } else if (t < 1.1/2) {
                    // Second third: pause at origin
                    k = 1;
                    x = 0;
                    y = 0;
                } else {
                    // Final third: zoom in to end position
                    const t3 = (t - 1.1/2) * 2;
                    k = 1 * (1 - t3) + endTransform.k * t3;
                    x = 0 * (1 - t3) + endTransform.x * t3;
                    y = 0 * (1 - t3) + endTransform.y * t3;
                }
            }
            transformRef.current = d3.zoomIdentity.translate(x, y).scale(k);
            updateVisiblePoints();
    
            if (t < 1) {
                requestAnimationFrame(animate);
            } else {
                // Ensure the zoom behavior is updated with the new transform
                if (zoomRef.current) {
                    d3.select(canvasRef.current).call(zoomRef.current.transform, transformRef.current);
                }
            }
        };
    
        requestAnimationFrame(animate);
    };

    function usePrevious(value) {
        const ref = useRef();
        useEffect(() => {
          ref.current = value;
        });
        return ref.current;
      }

    useEffect(() => {
        if (!searched) return;

        let targetTransform;
        if (currentCoord !== 'display') {
            targetTransform = d3.zoomIdentity
            .translate(
                width / 2 - values.zoomScale * searched[`${currentCoord}_x`],
                height / 2 - values.zoomScale * searched[`${currentCoord}_y`]
            )
            .scale(values.zoomScale);
        } else {
            targetTransform = d3.zoomIdentity
            .translate(
                width / 2 - 110 * searched[`${currentCoord}_x`],
                height / 2 - 110 * searched[`${currentCoord}_y`]
            )
            .scale(110);
        }

        data.find((t) => t.uuid === searched.uuid).zIndex = 2
        animateZoom(transformRef.current, targetTransform, transitionDuration);
        setSearchCard(searched, setExtraVisible, transitionDuration);
        setSearched('');
    }, [searched, transitionDuration, values, width, height]);

    const prevCoord = usePrevious(currentCoord);
    useEffect(() => {

        if (prevCoord !== currentCoord) {
            transformRef.current = d3.zoomIdentity.translate(0, 0).scale(1);
        }
        const canvas = canvasRef.current;

        const zoomed = (event) => {
            transformRef.current = event.transform;
            setThisZoom(transformRef.current.k);
            updateVisiblePoints();
        };

        const zoom = d3.zoom()
            .scaleExtent([0.5, 4000])
            .on('zoom', zoomed);

        zoomRef.current = zoom;

        d3.select(canvas).call(zoom);

        // Set initial transform state
        d3.select(canvas).call(zoom.transform, transformRef.current);

        updateVisiblePoints();

        canvas.addEventListener('click', handleCanvasClick);

        return () => {
            canvas.removeEventListener('click', handleCanvasClick);
        };
    }, [data, width, height, values, currentCoord]);

    useEffect(() => {
        transformRef.current = d3.zoomIdentity.translate(0, 0).scale(1);
        updateVisiblePoints();
    }, [currentCoord]);

    const handleCanvasClick = (event) => {
        if (transformRef.current.k > values.zoomDisplayImages) {
            const canvas = canvasRef.current;
            const rect = canvas.getBoundingClientRect();
            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;

            const clickedImage = data.filter(d => {
                const imageX = transformRef.current.applyX(d[`${currentCoord}_x`]);
                const imageY = transformRef.current.applyY(d[`${currentCoord}_y`]);
                return x >= imageX - values.width/2&& x <= imageX + values.width/2 && y >= imageY - values.height/2 && y <= imageY + values.height/2;
            });

            if (clickedImage.length > 0) {
                const topmostImage = clickedImage.reduce((topImage, currentImage) => {
                    return (currentImage.zIndex > topImage.zIndex) ? currentImage : topImage;
                });
                // setOverlayContent({...topmostImage, allImagesUrl: fullData.filter((t) => t.name === topmostImage.name).map((p) => p.image_url)});
                setDetailedCard(topmostImage);
            }
        }
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    // return (
    //     <canvas
    //         ref={canvasRef}
    //         width={width}
    //         height={height}
    //         style={{ border: '1px solid black' }}
    //     />
    // );
    return (
        <>
        <canvas
            ref={canvasRef}
            width={width}
            height={height}
            style={{ border: '1px solid black' }}
        />
        {overlayContent && (
                <DetailedCard
                    open={modalOpen}
                    uuid={overlayContent.uuid}
                    handleClose={handleCloseModal}
                    // imageSrc={overlayContent.image_url}
                    imageSrc={`${IMAGE_URL}${overlayContent.image_id[0]}/${overlayContent.image_id[1]}/${overlayContent.image_id}`}
                    color={COLORS[overlayContent.rarity]}
                    multiImageSrc={overlayContent.allImagesUrl}
                    legalities={overlayContent.legalities}
                    setDetailedCard={setDetailedCard}
                    total={fullData}
                />
            )}
    </>
    )
};

export default CanvasPoints;
